import { useArgusAuth } from "./useArgusAuth";
import { useEffect, useState } from "react";
import { ApiCallStatus } from "../utils/constants";
import { uniqBy } from "lodash";
import { fetchSearchSuggestions } from "../main-component/PageFunctions/productFunctions";
import ReactGA from "react-ga4";

const useArgusSearch = () => {
	const {isLoading} = useArgusAuth();
	const [searchTerm, setSearchTerm] = useState("");
	const [searchResults, setSearchResults] = useState([]);
	const [products, setProducts] = useState(null);

	const [searchResultsCallStatus, setSearchResultsCallStatus] = useState(ApiCallStatus.NotStarted);

	const fetchSearchSuggestionsAsync = async (signal) => {
		await fetchSearchSuggestions({
			searchTerm,
			signal,
			setSearchResults,
			setStatusInProgress: () => setSearchResultsCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setSearchResultsCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setSearchResultsCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setSearchResultsCallStatus(ApiCallStatus.Error)
		});
	};

	useEffect(() => {
		if (searchTerm && searchTerm.length > 2) {

			ReactGA.event({
				category: 'Ecommerce',
				action: 'Search',
				value: searchTerm,
				nonInteraction: false
			});

			setProducts(null);

			const controller = new AbortController();
			fetchSearchSuggestionsAsync(controller.signal);

			return () => controller.abort();
		} else {
			setSearchResults([]);
			setProducts(null);
			setSearchResultsCallStatus(ApiCallStatus.NotStarted);
		}
	}, [searchTerm]);

	useEffect(() => {
		if (!searchResults.products) return;

		setProducts(uniqBy(searchResults.products, (x) => x.sku));
	}, [searchResults?.products]);

	const allLoadingStates = [
		searchResultsCallStatus
	];

	const loading = allLoadingStates.includes(ApiCallStatus.InProgress);

	return {
		setSearchTerm,
		products,
		loading
	};
};

export default useArgusSearch;